<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between bg-gray-200 md:flex-shrink-0 md:justify-center md:w-56">
            <Link class="mt-1 mb-1" href="/">
              <logo class="fill-white" width="120" height="50" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <logo />
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-blue-800 rounded shadow-lg">
                  <!-- <main-menu :user="auth.user" :role="auth.user.role" /> -->
                </div>
              </template>
            </dropdown>
          </div>

          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-12 md:py-0">
            <div class="mr-4 mt-1 flex items-center space-x-2">
              <span>1$ = {{ change }} BsD</span>
              <Link
                href="/taxes"
                class="px-2 py-0.5 text-xs font-medium text-indigo-600 bg-indigo-50 hover:bg-indigo-100 hover:text-indigo-700 rounded border border-indigo-200 transition-colors shadow-sm"
              >
                Modificar tasa
              </Link>
            </div>
            <div class="font-semibold text-xl">
              {{ time }}
            </div>
            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <div class="group flex items-center cursor-pointer select-none">
                  <div class="mr-1 text-gray-700 group-hover:text-blue-600 focus:text-blue-600 whitespace-nowrap">
                    <span>{{ auth.user.first_name }}</span>
                    <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                  </div>
                  <icon class="w-5 h-5 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="cheveron-down" />
                </div>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <Link class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="`/users/${auth.user.id}/edit`">Mi perfil</Link>
                  <Link v-if="auth.user.role === 'admin'" class="block px-6 py-2 hover:text-white hover:bg-blue-500" href="/users">Usuarios</Link>
                  <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-blue-500" href="/logout" method="delete" as="button">Cerrar sesión</Link>
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <!-- <main-menu class="hidden flex-shrink-0 p-12 w-56 bg-blue-900 overflow-y-auto md:block rounded-b-lg" /> -->
          <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
  },
  props: {
    auth: Object,
    change: Number
  },
  data() {
    return {
      date: '',
      time: '',
      lastActivityTime: Date.now(),
      inactivityTimeoutMs: 60 * 60 * 1000, // 1 hora
      inactivityCheckInterval: null,
      activityEvents: ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click']
    }
  },
  mounted() {
    this.time = this.update()
    this.timeInterval = setInterval(() => {
      this.time = this.update();
    }, 1000)
    this.setupInactivityDetector()
  },
  beforeUnmount() {
    if (this.timeInterval) clearInterval(this.timeInterval)
    this.cleanupInactivityDetector()
  },
  methods: {
    recordActivity() {
      this.lastActivityTime = Date.now()
    },
    checkInactivity() {
      const idleTime = Date.now() - this.lastActivityTime
      if (idleTime >= this.inactivityTimeoutMs) {
        this.cleanupInactivityDetector()
        this.$inertia.delete('/logout', {
          onFinish: () => {
            window.location.href = '/login'
          }
        })
      }
    },
    setupInactivityDetector() {
      this.recordActivity()
      this.activityEvents.forEach(event => {
        window.addEventListener(event, this.recordActivity, { passive: true })
      })
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.checkInactivity()
        }
      })
      this.inactivityCheckInterval = setInterval(this.checkInactivity, 30000)
    },
    cleanupInactivityDetector() {
      if (this.inactivityCheckInterval) {
        clearInterval(this.inactivityCheckInterval)
        this.inactivityCheckInterval = null
      }
      this.activityEvents.forEach(event => {
        window.removeEventListener(event, this.recordActivity)
      })
    },
    zeroPadding: (num, digit) => {
      var zero = '';
      for(var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    },
    update: () => {
      let cd = new Date();
      let hours = '';
      let minutes = '';
      let secounds = '';
      let zero = '';

      for(let i = 0; i < 1; i++) {
        zero += '0';
      }
      hours = cd.getHours() > 9 ? cd.getHours() : (zero + cd.getHours())
      minutes =  cd.getMinutes() > 9 ? cd.getMinutes() : (zero + cd.getMinutes())
      secounds = cd.getSeconds() > 9 ? cd.getSeconds() :(zero + cd.getSeconds())

      return hours + ':' + minutes + ':' + secounds
    },
  }
}
</script>
